import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

import type { TrackingData } from '@ecomm/tracking-types/Data'

export function useTrackOdmonComparePlanClick() {
  const { trackEvent } = useTracking<TrackingData>()

  return useCallback(() => {
    trackEvent({
      event: 'compare-plan-click'
    })
  }, [trackEvent])
}
